import Vue from 'vue';
import Vuex from 'vuex';
import novel from "@/store/novel";
import settings from "@/store/settings";
import account from "@/store/account";
import metric from "@/store/metric";
import cashier from "@/store/cashier";
import item from "@/store/item";
import item_list from "@/store/item_list";
import comment from "@/store/comment";
import base from "@/store/base";
import notification from "@/store/notification";
import activity from "@/store/activity";
import item_action from "@/store/item_action";
import feedback from "@/store/feedback";
import moment from "@/store/moment";
import feed from "@/store/feed";
import goods from "@/store/goods";
import address from "@/store/address";
import order from "@/store/order";
import mp from "@/store/mp";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    novel,
    item,
    settings,
    account,
    metric,
    cashier,
    item_list,
    base,
    comment,
    notification,
    activity,
    item_action,
    feedback,
    moment,
    feed,
    goods,
    address,
    order,
    mp,
  },
});
